import React, { useCallback } from 'react'
import { saveToLocalStorage } from '../../store'
import { useDropzone } from 'react-dropzone'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import styled from '@emotion/styled'
import '../../index.css'

const Upload = styled.span`
  color: rgba(0, 0, 0, 0.87);
`
const Bold = styled.span`
  font-weight: bold;
  cursor: pointer;
  text-decoration: underline;
`

export default function UploadLS() {
  const [open, setOpen] = React.useState(false)

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleOk = () => {
    setOpen(false)
  }

  const onDrop = useCallback(acceptedFiles => {
    acceptedFiles.forEach(() => {
      // eslint-disable-next-line no-undef
      const reader = new FileReader()

      reader.onabort = () => console.log('file reading was aborted')
      reader.onerror = () => console.log('file reading has failed')
      reader.onload = async function (e) {
        var obj = e.target.result
        var intern = JSON.parse(obj)
        saveToLocalStorage(intern)

        handleClose()
      }
      acceptedFiles.forEach(file => reader.readAsBinaryString(file))
    })
  }, [])

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: '.json',
  })

  return (
    <div>
      <Upload onClick={handleClickOpen}>
        <Bold>Upload LocalStorage</Bold> (reload page after uploading)
      </Upload>
      <Dialog disableEscapeKeyDown open={open} onClose={handleClose}>
        <DialogTitle id="form-dialog-title">Upload LocalStorage</DialogTitle>
        <DialogContent>
          <section className="container">
            <div {...getRootProps({ className: 'dropzone' })}>
              <img
                style={{ width: '40px', height: '40px' }}
                src="http://www.file-extension.info/images/resource/formats/geojson.png"
                alt=""
              />
              <input style={{ textAlign: 'center' }} {...getInputProps()} />
              <p>Drag and drop, or click to select your LocalStorage file.</p>
              <p>Reload the page after uploading.</p>
              <em>(Only *.json files will be accepted)</em>
            </div>
          </section>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleOk} color="primary">
            ADD
          </Button>
          <Button onClick={handleClose} color="primary">
            CANCEL
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
